export default {
  auto: ['actions'],
}



// WEBPACK FOOTER //
// ./src/store/modules/recoveries.js